import { parseColorHexRGB } from '@microsoft/fast-colors';
import { SwatchRGB } from '@microsoft/fast-components';
export const darkColors = {
    foregroundSwatch: SwatchRGB.from(parseColorHexRGB('#cccccc')),
    headerForegroundSwatch: SwatchRGB.from(parseColorHexRGB('#879ba6')),
    backgroundSwatch: SwatchRGB.from(parseColorHexRGB('#1f2126')),
    borderSwatch: SwatchRGB.from(parseColorHexRGB('#2e3339')),
    rowHoverSwatch: SwatchRGB.from(parseColorHexRGB('#2b2e34')),
};
export const lightColors = {
    foregroundSwatch: SwatchRGB.from(parseColorHexRGB('#000000')),
    headerForegroundSwatch: SwatchRGB.from(parseColorHexRGB('#181d1f')),
    backgroundSwatch: SwatchRGB.from(parseColorHexRGB('#FFFFFF')),
    borderSwatch: SwatchRGB.from(parseColorHexRGB('#babfc7')),
    rowHoverSwatch: SwatchRGB.from(parseColorHexRGB('#2196f3')),
};
